import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ValidationService } from '@core/services/validation.service';
import { MatIconModule } from '@angular/material';

import { FieldControlErrorMessagesComponent } from './field-control-error-mesages/field-control-error-messages.component';
import { UnexpectedErrorComponent } from './unexpected-error/unexpected-error.component';
import { ErrorScreenComponent } from './error-screen/error-screen.component';

@NgModule({
  declarations: [
    FieldControlErrorMessagesComponent,
    UnexpectedErrorComponent,
    ErrorScreenComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  entryComponents: [
    UnexpectedErrorComponent,
    ErrorScreenComponent
  ],
  providers: [
    ValidationService
  ],
  exports: [
    FieldControlErrorMessagesComponent,
    UnexpectedErrorComponent,
    ErrorScreenComponent
  ]
})
export class UiErrorsModule { }
